import { render, staticRenderFns } from "./home_comb.vue?vue&type=template&id=07cb6b08&scoped=true&"
import script from "./home_comb.vue?vue&type=script&lang=js&"
export * from "./home_comb.vue?vue&type=script&lang=js&"
import style0 from "./home_comb.vue?vue&type=style&index=0&id=07cb6b08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cb6b08",
  null
  
)

export default component.exports